import { read, update } from '@/api/rest';

const checkpointQuality = {
  performerQualities: async (params) =>
    await read('/checkpoint-quality/performer-qualities?' + params.toString()),
  savePerformerQualities: async (data) =>
    await update('/checkpoint-quality/save-performer-qualities', data),
  confirm: async (id, data) =>
    await update(`/checkpoint-quality/confirm-quality/${id}`, data),
};
export default checkpointQuality;
